import { Select } from 'antd'
import { DataContext } from 'contexts/DataContextContainer'
import { useAtom } from 'jotai'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { bookIdAtom } from 'store/atoms'
import { useBookRoleQuery, useUserBooksQuery } from 'store/queries'
import { BooksListContainer } from './style'

function BooksList() {
  const history = useHistory()
  const { loggedInUser } = useContext(DataContext)
  const [bookId] = useAtom(bookIdAtom)
  const { data: role } = useBookRoleQuery(bookId)
  const { data: userBooks } = useUserBooksQuery(loggedInUser?.id)

  const onChange = (bookId) => {
    history.push(`/dashboard/book/${bookId}/info`)
  }

  return (
    <BooksListContainer>
      <div className="books-list">
        {userBooks?.length > 1 ? (
          <Select
            className="bl-select"
            onChange={onChange}
            options={userBooks.map((book) => ({
              value: book.id,
              label: book.title,
            }))}
            value={parseInt(bookId)}
          />
        ) : (
          <h4 className="selected">
            {userBooks && userBooks[0] && userBooks[0].title}
          </h4>
        )}
        <h4 className="selected">&nbsp;{role && `- ${role.name}`}</h4>
      </div>
    </BooksListContainer>
  )
}

export default BooksList
